module.exports = __webpack_public_path__ + "img/ouropreto.478b7c68.png";